var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "price-field" },
    [
      _c(
        "div",
        { staticClass: "price-header" },
        [
          _c("el-checkbox", {
            attrs: { "active-text": "Flexible", "inactive-text": "Fixed" },
            model: {
              value: _vm.price.is_flexible,
              callback: function($$v) {
                _vm.$set(_vm.price, "is_flexible", $$v)
              },
              expression: "price.is_flexible"
            }
          }),
          _vm._v(" "),
          _c("label", { staticClass: "contactum-label" }, [
            _vm._v(" " + _vm._s(" Use flexible price") + " ")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.price.is_flexible
        ? [
            _c("div", { staticClass: "price-range" }, [
              _c(
                "div",
                { staticClass: "price-input-item" },
                [
                  _c("label", { staticClass: "contactum-label" }, [
                    _vm._v("  " + _vm._s("Minimum Price") + " ")
                  ]),
                  _vm._v(" "),
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      min: 0,
                      placeholder: "Min",
                      "controls-position": "right"
                    },
                    model: {
                      value: _vm.price.min,
                      callback: function($$v) {
                        _vm.$set(_vm.price, "min", $$v)
                      },
                      expression: "price.min"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "price-input-item" },
                [
                  _c("label", { staticClass: "contactum-label" }, [
                    _vm._v(" " + _vm._s("Maximum Price") + " ")
                  ]),
                  _vm._v(" "),
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      min: _vm.price.min || 0,
                      placeholder: "Max",
                      "controls-position": "right"
                    },
                    model: {
                      value: _vm.price.max,
                      callback: function($$v) {
                        _vm.$set(_vm.price, "max", $$v)
                      },
                      expression: "price.max"
                    }
                  })
                ],
                1
              )
            ])
          ]
        : [
            _c(
              "div",
              { staticClass: "panel" },
              [
                _c("label", { staticClass: "contactum-label" }, [
                  _vm._v("Price")
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    min: 0,
                    "controls-position": "right",
                    placeholder: "Enter price"
                  },
                  model: {
                    value: _vm.price.price,
                    callback: function($$v) {
                      _vm.$set(_vm.price, "price", $$v)
                    },
                    expression: "price.price"
                  }
                })
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }